import { createTheme } from '@mui/material/styles';
import { blue, purple } from '@mui/material/colors';

export const theme = createTheme({
  palette: {
    primary: {
      main: '#e4352e'
    },
    secondary: {
      main: '#f44336',
    },
  },
});